import type {
  ColorCode,
  ColorStyledProps,
  GetStyles,
  Palette,
  Split,
  Theme,
} from '@sds-system/types';

export const getColorValue = (colorCode: ColorCode, theme: Theme): string => {
  if (!colorCode) {
    throw new Error('colorCode가 존재하지 않습니다.', { cause: 'not required' });
  }
  if (!/(\w+)\.(\w+)(\.(\w+))?/g.test(colorCode) || colorCode.includes('rgba')) {
    // throw new Error(`알맞은 형식의 colorCode가 아닙니다. - ${colorCode}`, { cause: 'not matched' });
    return colorCode;
  }

  let color = '';

  const splitColorCode = colorCode.split('.') as Split<'.', typeof colorCode>;
  const code1 = splitColorCode[0];
  const code2 = splitColorCode[1] as keyof Palette[typeof code1];

  const theme1 = theme.palette[code1];
  const theme2 = theme1?.[code2] as Palette[typeof code1];
  if (!theme2) {
    throw new Error(
      `첫번째 palette가 가지고 있지 않은 색깔 
      전체 컬러코드 - ${colorCode}
      오류발생 코드 - ${code2}`,
      {
        cause: 'not child of parent palette',
      },
    );
  }
  if (typeof theme2 === 'string') {
    color = getColorValue(theme2, theme);
  }
  if (typeof theme2 === 'object') {
    const code3 = splitColorCode[2] as keyof typeof theme2;
    if (code3) {
      const theme3 = theme2[code3];
      color = getColorValue(theme3, theme);
    }
  }

  return color;
};

export const getColorStyles: GetStyles<ColorStyledProps> = ({ theme, color, bgColor }) => {
  return {
    color: color && getColorValue(color, theme),
    backgroundColor: bgColor && getColorValue(bgColor, theme),
  };
};
